import { render, staticRenderFns } from "./PaiementUpdate.vue?vue&type=template&id=b4353aa8"
import script from "./PaiementUpdate.vue?vue&type=script&lang=js"
export * from "./PaiementUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports